import axios from 'axios';
import globals from "../config/appconfig";

export default class SiavrServices {

    static urlGetVaccinazioni = globals["app-url-backend-siavr"] + "/getVaccinazioni"

    static getVaccinazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetVaccinazioni + querystring)
    }

}